// MemberForm.jsx
import React, { useState } from "react";
import Swal from "sweetalert2";
import { inviteMember } from "../../api/api";
import "./MemberForm.css";

const MemberForm = ({ workspace_id, onMemberCreated }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("member");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return alert("Email required");

    setLoading(true);
    try {
      // Call backend to create member and get password
      const res = await inviteMember(workspace_id, name, email, role);

      const password = res.password || null;

      onMemberCreated();
      setName("");
      setEmail("");
      setRole("member");

      if (password) {
        // Show SweetAlert with password
        Swal.fire({
          title: "Member Added",
          html: `
            <p><b>Email:</b> ${email}</p>
            <p><b>Password:</b> <span id="generated-password">${password}</span></p>
          `,
          showCancelButton: false,
          confirmButtonText: "Copy & Close",
          icon: "success",
        }).then(() => {
          // Copy password to clipboard and close
          const passwordText = document.getElementById("generated-password").innerText;
          navigator.clipboard.writeText(passwordText);
        });
      } else {
        Swal.fire({
          icon: "success",
          title: "Member Added",
          text: `Member already existed. Password sent via email.`,
        });
      }

    } catch (err) {
      console.error(err);
      Swal.fire({
        icon: "error",
        title: "Failed to add member",
        text: err.msg || "Something went wrong",
      });
    }
    setLoading(false);
  };

  return (
    <form onSubmit={handleSubmit} className="member-form">
      <div className="form-group">
        <label className="form-label">Member Name</label>
        <input
          type="text"
          className="form-input"
          placeholder="John Doe"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />
      </div>

      <div className="form-group">
        <label className="form-label">Email Address</label>
        <input
          type="email"
          className="form-input"
          placeholder="member@company.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
      </div>

      <div className="form-group">
        <label className="form-label">Role</label>
        <select
          className="form-select"
          value={role}
          onChange={(e) => setRole(e.target.value)}
        >
          <option value="member">Member</option>
          <option value="admin">Admin</option>
          <option value="viewer">Viewer</option>
        </select>
      </div>

      <button type="submit" className="submit-button" disabled={loading}>
        {loading ? "Adding..." : "Invite Member"}
      </button>
    </form>
  );
};

export default MemberForm;